module.exports = require('./assignIn');